/** Combine team/location filters while keeping counts useful across teams. */
export function filterCareers({jobs, department = 'None', location = 'None'}) {
    const inTeam = (job) => department === 'None' || job.department === department;
    const inLocation = (job) => location === 'None' || job.location === location;
    const teamCounts = new Map([['None', 0]]);
    const alternativeLocations = new Map();
    for (const job of jobs) {
        if (inLocation(job)) {
            teamCounts.set('None', teamCounts.get('None') + 1);
            teamCounts.set(job.department, (teamCounts.get(job.department) || 0) + 1);
        } else if (inTeam(job) && job.location) {
            alternativeLocations.set(job.location, (alternativeLocations.get(job.location) || 0) + 1);
        }
    }
    return {
        visibleJobs: jobs.filter((job) => inTeam(job) && inLocation(job)),
        teamCounts,
        alternativeLocations,
    };
}

export function emptyCareersMessage(department, location) {
    const team = department === 'None' ? '' : ` on the ${department} team`;
    const place = location === 'None' ? '' : ` in ${location}`;
    return `No open positions${team}${place} right now.`;
}
